import { render, staticRenderFns } from "./body-statistic.vue?vue&type=template&id=6e131beb"
import script from "./body-statistic.vue?vue&type=script&lang=js"
export * from "./body-statistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports